/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { PortalWebsite, Settings, Tag } from '@api/model';
import { IAction } from '../../models/IshAction';
import { PortslWebsiteUpdateFields } from '../../models/Portal';
import { FULFILLED } from './ActionUtils';

export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';
export const GET_SETTINGS = 'GET_SETTINGS';
export const GET_SETTINGS_FULFILLED = FULFILLED(GET_SETTINGS);

export const GET_TAGS = 'GET_TAGS';
export const GET_TAGS_FULFILLED = FULFILLED(GET_TAGS);

export const GET_PORTAL_WEBSITES = 'GET_PORTAL_WEBSITES';
export const GET_PORTAL_WEBSITES_FULFILLED = FULFILLED(GET_PORTAL_WEBSITES);

export const DELETE_PORTAL_WEBSITE = 'DELETE_PORTAL_WEBSITE';

export const UPDATE_PORTAL_WEBSITE = 'UPDATE_PORTAL_WEBSITE';

export const getTags = (): IAction => ({
  type: GET_TAGS
});

export const getSettings = (): IAction => ({
  type: GET_SETTINGS
});

export const deletePortalWebsite = (id: number): IAction<number> => ({
  type: DELETE_PORTAL_WEBSITE,
  payload: id
});

export const getPortalWebsites = (navigateToLast?: boolean): IAction<boolean> => ({
  type: GET_PORTAL_WEBSITES,
  payload: navigateToLast
});

export const updateSettings = (settings: Settings): IAction => ({
  type: UPDATE_SETTINGS,
  payload: settings
});

export const updatePortalWebsite = (...args: Partial<PortslWebsiteUpdateFields> ): IAction => ({
  type: UPDATE_PORTAL_WEBSITE,
  payload: args
});

export const getSettingsFulfilled = (settings: Settings): IAction => ({
  type: GET_SETTINGS_FULFILLED,
  payload: settings
});

export const getPortalWebsiteFulfilled = (portalWebsites: PortalWebsite[]): IAction => ({
  type: GET_PORTAL_WEBSITES_FULFILLED,
  payload: portalWebsites
});

export const getTagsFulfilled = (tags: Tag[]): IAction => ({
  type: GET_TAGS_FULFILLED,
  payload: tags
});
